import { AnchorButton } from '@payaca/ambrosia';
import type { FC, ReactNode } from 'react';
import { Link } from 'react-router-dom';

import {
  getRoute,
  isExternalUrl,
  isSupportedEntityType,
  parsePayacaUri,
} from './entityLinkUtils';

interface EntityLinkProps {
  href: string;
  children: ReactNode;
}

export const EntityLink: FC<EntityLinkProps> = ({ href, children }) => {
  const parsed = parsePayacaUri(href);

  // Not a payaca:// URI - check if external link
  if (!parsed) {
    if (isExternalUrl(href)) {
      return (
        <AnchorButton href={href} variant="link" openInNewTab>
          {children}
        </AnchorButton>
      );
    }
    // Unknown protocol or malformed - render as plain text
    return <span>{children}</span>;
  }

  // Wrong app namespace - render as plain text
  if (parsed.app !== 'provider') {
    return <span>{children}</span>;
  }

  // Unsupported entity type - render as plain text
  if (!isSupportedEntityType(parsed.entityType)) {
    return <span>{children}</span>;
  }

  // Supported entity - render as React Router link
  const route = getRoute(parsed.entityType, parsed.publicId);
  return (
    <AnchorButton as={Link} to={route} variant="link">
      {children}
    </AnchorButton>
  );
};
